import { useSelector } from "react-redux";
import useAuthSelectors from "./auth";
import useToolsSelectors from "./tools";
import useUsersSelectors from "./users";
import useRolesSelectors from "./roles";
import useProjectsSelectors from "./projects";

const useSelectors = () => {
  return {
    useSelector,
    useAuthSelectors,
    useToolsSelectors,
    useUsersSelectors,
    useRolesSelectors,
    useProjectsSelectors,
  };
};

export default useSelectors;
